// extracted by mini-css-extract-plugin
export default {"button":"styles_button__Qm63h","text":"styles_text__qMB4J","locationPin":"styles_locationPin__nQEs0"};